export function parseStreamEventData(rawData: string) {
  try {
    return JSON.parse(rawData);
  } catch {
    return rawData;
  }
}

export function parseSseFrame(frame: string) {
  const lines = frame.split(/\r?\n/);
  let id: string | undefined;
  let event = "message";
  const dataLines: string[] = [];

  for (const line of lines) {
    if (!line || line.startsWith(":")) {
      continue;
    }

    if (line.startsWith("id:")) {
      id = line.slice("id:".length).trimStart();
      continue;
    }

    if (line.startsWith("event:")) {
      event = line.slice("event:".length).trimStart();
      continue;
    }

    if (line.startsWith("data:")) {
      dataLines.push(line.slice("data:".length).trimStart());
    }
  }

  if (dataLines.length === 0) {
    return null;
  }

  return {
    id,
    event,
    rawData: dataLines.join("\n"),
  };
}
